export const VampiresStory = {
    level: 10,
    name: 'Vampires',
    cpu1Name: 'Veira, the Temptress',
    cpu2Name: 'Ravyn, Blood Knight',
    cpu3Name: 'Countess Lyssara',
    text: 'Vampires need help sometimes too. And they’re not evil at all — they just have a special diet.',
    classCss: 'map-vampires-ico',
    cpu1: {
        id: 28,
        before: {
            type: 'comics',
            comicsSetting: {
                path: './img/stories/vampire/intro/',
                slideNumber: 22
            }
        },
        after: {
            player: {
                type: 'text',
                step: {
                    0: "Very good. Thank you for not messing up my body too much.",
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'Even though I probably shouldn’t be saying this — since it  my magnificent body — but try using more powerful spells, like Lightning, for example.',
                }
            }
        }
    },
    cpu2: {
        id: 29,
        before: {
            type: 'text',
            step: {
                0: "Be careful — vampire knights are very strong in battle. One mistake and you’re done for.",
            }
        },

        after: {
            player: {
                type: 'text',
                step: {
                    0: "You're a hero! You're the first person I know who has managed to defeat a vampire knight in battle.",
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'You need speed. A vampire knight can only be defeated before he’s had his fill of blood.',
                }
            }
        }
    },
    cpu3: {
        id: 30,
        before: {
            type: 'text',
            step: {
                0: "I think this will be easy. Noble vampire ladies are very lazy — they don\'t know how to do anything and spend their days doing nothing but partying and entertaining themselves.",
            }
        },
        after: {
            cpu: {
                type: 'text',
                step: {
                    0: 'Oops, I forgot that noble vampires have a bunch of servants. In that case, you’ll need something powerful — like a single spell that can wipe out all the servants at once.',
                }
            },
            player: {
                type: 'comics',
                comicsSetting: {
                    path: './img/stories/vampire/win/',
                    slideNumber: 8,
                    animatedSlides: [8]
                }
            }
        },
    },
    cpu4: {
        id: 43,
        before: {
            type: 'text',
            step: {
                0: 'Let’s unleash a bloody bacchanalia!!! I’m calling everyone — it’s going to be epic!',
            }
        },

        after: {
            player: {
                type: 'text',
                step: {
                    0: "Well? Did you like it? Maybe someday we’ll turn you into a vampire too — it’s fun and tasty!",
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'Yum! Yum! Yum! That was really tasty. Let’s do it again!',
                }
            }
        }
    },
}
